import { useId, type ChangeEvent, type InputHTMLAttributes } from "react";
import { sanitizeAmountInput } from "../lib/format";

interface MoneyInputProps extends InputHTMLAttributes<HTMLInputElement> {
  currencySymbol?: string;
  label?: string;
}

export function MoneyInput({
  currencySymbol = "$",
  label,
  className = "",
  onChange,
  ...props
}: MoneyInputProps) {
  const id = useId();

  function handleChange(e: ChangeEvent<HTMLInputElement>) {
    e.target.value = sanitizeAmountInput(e.target.value);
    onChange?.(e);
  }

  return (
    <div className="flex flex-col gap-1">
      {label && (
        <label htmlFor={id} className="font-sans text-xs font-medium text-muted">
          {label}
        </label>
      )}
      <div className="relative">
        <span className="absolute left-0 top-1/2 -translate-y-1/2 text-muted pointer-events-none select-none">
          {currencySymbol}
        </span>
        <input
          id={id}
          autoComplete="off"
          {...props}
          type="text"
          inputMode="decimal"
          onChange={handleChange}
          className={`w-full bg-transparent text-fg border-b border-hairline pl-6 pr-0 py-3
            focus:outline-none focus:border-fg
            placeholder:text-faint font-mono [font-variant-numeric:tabular-nums]
            disabled:opacity-50 ${className}`}
        />
      </div>
    </div>
  );
}
